<div fxLayout="column" style="padding:15px; margin-bottom: 60px;">

    <app-page-header title="Δραστηριότητες" action=''></app-page-header>

    <div fxLayout="column" fxLayoutAlign="start center center" style="margin-top:50px;">

        <div fxLayout="column" style="margin-top:50px;" fxFlex="100">
            <div fxLayout="row" fxFlex="100" style="width:400px;">
                <mat-form-field fxFlex="95">
                    <label>
                        <input matInput [(ngModel)]="newActivity" type="text" placeholder="Περιγραφή δραστηριότητας"/>
                    </label>
                </mat-form-field>

                <button mat-icon-button fxFlex="5" matTooltip="Προσθήκη" (click)="insertActivity()"><mat-icon>add</mat-icon></button>

            </div>
        </div>
        <div ngStyle.md="width:100%" ngStyle.lt-md="width:100%" ngStyle.gt-md="width:55%" ngStyle.lg="width:55%" fxLayout="row" style="margin-top:20px; ">

            <div class="questionsContainer" fxLayout="column"   fxFlex style=" width:100%;">
                <ng-container *ngIf="loadingActivities; else ShowQuestions">
                    <app-loading></app-loading>
                </ng-container>

                <ng-template #ShowQuestions>
                    <div fxLayout="column">
                        <div *ngFor="let activity of activities" fxLayout="column" style="border-bottom: 1px solid lightgray; margin-top: 20px; padding: 20px;">

                            <!--          <div fxFlex="5" fxLayoutAlign="center center">-->
                            <!--            {{activity.id}}-->
                            <!--          </div>-->

                            <div fxLayout="row">
                                <div fxFlex="90" fxLayoutAlign="start center">
                                    {{activity.description}}
                                </div>

                                <div fxFlex="10" fxLayoutAlign="center center center" fxLayout="column">
                                    <div fxLayout="row" fxLayoutAlign="center center center">
                                        <button [disabled]="levels.length === 0" mat-icon-button
                                                [matTooltip]="levels.length === 0 ? 'Δεν υπάρχουν επίπεδα προς ανάθεση' : 'Ανάθεση επιπέδων'"
                                                (click)="assignLevelsToActivity(activity)">
                                            <mat-icon>merge_type</mat-icon>
                                        </button>
                                        <button mat-icon-button matTooltip="Διαγραφή" (click)="confirmDeletion(activity)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </div>

                                </div>
                            </div>
                            <div fxLayout="row">
                                <mat-chip-list aria-label="Fish selection" style="margin-top: 20px;">
                                    <mat-chip *ngFor="let chip of activity.assignedLevels" fxLayoutAlign="center center center"
                                              style="background-color: var(--primary);
                        border-style: ridge; border: 1px var(--primary); color: white">{{chip.description}}</mat-chip>
                                </mat-chip-list>
                            </div>

                        </div>
                    </div>
                </ng-template>
            </div>

        </div>

    </div>






</div>
